import { useEffect, useRef, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { Symbol } from './Grundbausteine';

/**
 * Detailfenster von rechts (Prototyp presentDrawer/closeDrawer): erscheint nach zwei Bildern mit „open“,
 * schließt schneller als es öffnet, Rahmen dahinter ist inert, Fokus auf „Schließen“ und zurück.
 * Liegt direkt im body: Seiten rendern es in <main>, und das liegt in der inerten .shell (sonst wäre nichts darin klickbar).
 */
export function Detailfenster({ offen, schliessen, kopf, fuss, children, titelId = 'drTitle' }: {
  offen: boolean; schliessen: () => void; kopf: ReactNode; fuss?: ReactNode; children: ReactNode; titelId?: string;
}) {
  const [sichtbar, setSichtbar] = useState(offen);
  const [an, setAn] = useState(false);
  const zu = useRef<HTMLButtonElement>(null);
  const vorher = useRef<HTMLElement | null>(null);

  useEffect(() => {
    const rahmen = [document.querySelector<HTMLElement>('.shell'), document.querySelector<HTMLElement>('.topbar')];
    if (offen) {
      vorher.current = document.activeElement as HTMLElement | null;
      setSichtbar(true);
      rahmen.forEach(el => { if (el) el.inert = true; });
      // Zwei Bilder für den Übergang; ohne Bilder (Tab im Hintergrund) nach kurzer Zeit trotzdem öffnen
      let aktiv = true;
      const los = () => { if (aktiv) { aktiv = false; setAn(true); zu.current?.focus(); } };
      requestAnimationFrame(() => requestAnimationFrame(los));
      const t = setTimeout(los, 100);
      return () => { aktiv = false; clearTimeout(t); };
    }
    setAn(false);
    rahmen.forEach(el => { if (el) el.inert = false; });
    const t = setTimeout(() => { setSichtbar(false); vorher.current?.focus?.(); }, 200);
    return () => clearTimeout(t);
  }, [offen]);

  useEffect(() => {
    if (!offen) return;
    const taste = (e: KeyboardEvent) => { if (e.key === 'Escape') schliessen(); };
    document.addEventListener('keydown', taste);
    return () => document.removeEventListener('keydown', taste);
  }, [offen, schliessen]);

  useEffect(() => () => { [document.querySelector<HTMLElement>('.shell'), document.querySelector<HTMLElement>('.topbar')].forEach(el => { if (el) el.inert = false; }); }, []);

  return createPortal(
    <>
      <div className={an ? 'scrim open' : 'scrim'} id="drawerScrim" hidden={!sichtbar} onClick={schliessen} />
      <aside className={an ? 'drawer open' : 'drawer'} id="drawer" role="dialog" aria-modal="true" aria-labelledby={titelId} hidden={!sichtbar}>
        <div className="drawer-head"><div>{kopf}</div><button ref={zu} className="btn btn-ghost icon-btn" id="drClose" aria-label="Detailfenster schließen" onClick={schliessen}><Symbol id="x" /></button></div>
        <div className="drawer-body">{children}</div>
        <div className="drawer-foot">{fuss}<button className="btn" id="drDone" onClick={schliessen}>Schließen</button></div>
      </aside>
    </>,
    document.body
  );
}
